module.exports = __webpack_public_path__ + "static/media/29EUNOG6.45b4d6dd.jpg";